<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/tasklist' }">任务单列表</el-breadcrumb-item>
      <el-breadcrumb-item>任务单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <span class="item-label">创建日期</span>
          <el-date-picker
            v-model="tableOptions.startTime"
            type="datetime"
            style="width: 200px"
            placeholder="选择开始时间"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
          <el-date-picker
            v-model="tableOptions.endTime"
            type="datetime"
            style="width: 200px"
            placeholder="选择结束时间"
            default-time="23:59:59"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
        </div>
        <div class="toolbar-item">
          <el-button type="primary" size="small" @click="handleSearch" id="auto-1">筛选</el-button>
          <router-link :to="{ path: '/tasklist' }">
            <el-button type="primary" size="small" class="ml-10" id="auto-2">返回任务列表</el-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="table-custom-box mt-10" id="auto-3">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #expand="{ scope }">
          <el-table-column width="40" type="expand">
            <template v-slot="scope">
              <el-form label-position="left" inline class="self-table-expand">
                <el-form-item label="运单创建日期">
                  <span>{{ scope.row.orderCreateDate | stamp2TextDateFull(2) }}</span>
                </el-form-item>
                <el-form-item label="司机手机号">
                  <span>{{ scope.row.driverPhone }}</span>
                </el-form-item>
                <el-form-item label="装货签到">
                  <span>{{ scope.row.loadTime | stamp2TextDateFull(2) }}</span>
                </el-form-item>
                <el-form-item label="卸货签到">
                  <span>{{ scope.row.uploadTime | stamp2TextDateFull(2) }}</span>
                </el-form-item>
                <el-form-item label="委托派车">
                  <span v-if="scope.row.isHaulageOperator">是</span>
                  <span v-else>否</span>
                </el-form-item>
                <el-form-item label="支付方式">
                  <div>
                    <span>{{ scope.row.paymentTypeDesc }}</span>
                    <span v-if="scope.row.creditPay == 2 || scope.row.creditPay == 5"
                      >（{{ scope.row.laterPayDays }}天）</span
                    >
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-tag v-if="scope.row.isEtc" type="success">ETC</el-tag>
                  <el-tag v-if="scope.row.isOil" type="success">油费</el-tag>
                  <el-tag v-if="scope.row.isAgent" type="success">经纪人</el-tag>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </template>
        <template #createDate="{ scope }">
          <span>{{ scope.row.createDate | stamp2TextDate }}</span>
        </template>
        <template #orderNumber="{ scope }">
          <span class="font-green pointer" @click="showDetail(scope.row)">{{ scope.row.orderNumber }}</span>
        </template>
        <template #freightRates="{ scope }">
          <span class="font-orange">{{ scope.row.freightRates | thousands(2) }}元</span>
        </template>
        <template #driverIncome="{ scope }">
          <span class="font-orange">{{ scope.row.driverIncome | thousands(2) }}元</span>
        </template>
        <template #handle="{ scope }">
          <el-button
            v-if="isShowBtn(scope.row.orderState)"
            type="text"
            class="font-size12 font-blue"
            @click="handleConfirm(scope.row)"
            >取消运单</el-button
          >
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:3
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      axiosConfig: { url: api.getOrdersCheduleList }, // 列表接口
      columns: [
        { label: '趟次', prop: 'workTimes', 'min-width': 50 },
        { label: '运单号', prop: 'orderNumber', 'min-width': 140 },
        { label: '运单状态', prop: 'orderStateMemo', 'min-width': 120 },
        { label: '承运司机', prop: 'driverName', 'min-width': 90 },
        { label: '车牌号码', prop: 'driverPlateCode', 'min-width': 90 },
        { label: '重量/体积', prop: 'stockUnit', 'min-width': 90 },
        { label: '下单运费', prop: 'freightRates', 'min-width': 100 },
        { label: '实付运费', prop: 'driverIncome', 'min-width': 90 },
        { label: '操作', prop: 'handle', 'min-width': 90 }
      ],
      tableOptions: {
        orderScheduleCode: this.$route.params.key,
        startTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime()
      },
      isShowBtn: orderState => {
        // 判断取消按钮是否显示 [1, 3, 4, 5, 6, 7, 13]这些状态下才会显示取消按钮
        return [1, 3, 4, 5, 6, 7, 13].indexOf(orderState) != -1;
      }
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    showDetail(row) {
      // 跳转运单详情
      var url = './orderdetail.html#/' + row.orderNumber;
      window.open(url);
    },
    handleConfirm(row) {
      // [1, 3, 4, 5, 6, 7, 13]这些状态下才会显示取消按钮  确认司机之前调关闭，企业确定司机后跳转取消页面（没有付钱就是关闭，付钱之后就是取消）
      // 1，3，13 状态下(未装货签到) 应该直接调关闭
      // 4，5，6，7 跳转到取消页面
      // 12 取消中
      var orderState = row.orderState;
      if (orderState == 1 || orderState == 3 || orderState == 13) {
        // 确认司机之前调关闭
        this.closeOrderDirect(row);
      } else if (orderState == 4 || orderState == 5 || orderState == 6 || orderState == 7) {
        // 企业确定司机后 跳转取消页面
        this.$router.push({
          name: 'TaskCancelOrder',
          params: { orderNumbers: row.orderNumber, isSingle: 1 }
        });
      } else {
        //某些不可取消的状态
      }
    },
    // 关闭运单
    closeOrderDirect(row) {
      this.$confirm('确认要关闭该笔运单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          axios.post(api.cancelOrder, { orderNumber: row.orderNumber }).then(res => {
            this.$message.success('运单已关闭');
            this.handleSearch();
          });
        })
        .catch(() => {});
    }
  }
};
</script>
